<div class="w-100 c-sidebar" [class.out]="menuSideBar">
  <div class="menuSideBar" (click)="menuSideBar = !menuSideBar" [class.out]="menuSideBar">
    <i class="pi pi-angle-right" *ngIf="!menuSideBar"></i>
    <i class="pi pi-angle-left" *ngIf="menuSideBar"></i>
  </div>
  <div class="body-details p-2">
    <ul class="gs-accordion--list">
      <li class="level-1 level-heading" routerLinkActive="active">
        <a href="javascript:void(0)" routerLink="/setting/tasks/job-type" style="margin-top: 12px">Task Manager</a>
        <hr class="mt-2 mb-2" style="color: grey" />
        <ul class="level-2 list-unstyled" id="accordion">
          <!-- 01 - Job -->
          <li routerLinkActive="level-2-active">
            <a
              class="h3-heading"
              href="javascript:void(0)"
              routerLink="/setting/tasks/job-type"
              *ngxPermissionsOnly="['task.jobtype.manage']"
              routerLinkActive="active-highlight"
              >Task Type</a
            >
            <!-- New Template -->
            <div id="collapse1" class="collapse" data-parent="#accordion" [class.show]="job_type" routerLinkActive="show">
              <ul class="job-child">
                <div class="my-2 ml-1 site-searchbox position-relative with-left-icon">
                  <input
                    type="text"
                    class="site-input search-input"
                    [(ngModel)]="searchQuery"
                    (input)="fetchBySearch()"
                    placeholder="Search Task Type" />
                  <i class="pi pi-search cp cs-icon" *ngIf="!searchQuery"></i>
                  <button (click)="getData(); searchQuery = ''" type="reset" class="close-icon sm cs-icon" *ngIf="searchQuery"></button>
                </div>
                <li
                  class="d-flex align-items-center justify-content-between cursor-pointer"
                  (click)="showJobType = !showJobType"
                  [class.open]="showJobType"
                  [class.close]="!showJobType">
                  <a href="javascript:void(0);" [class.open]="showJobType" [class.close]="!showJobType"> All </a>
                  <ng-container *ngIf="showJobType; else down_angle">
                    <i class="pi pi-angle-down"></i>
                  </ng-container>
                  <ng-template #down_angle>
                    <i class="pi pi-angle-up"></i>
                  </ng-template>
                </li>
                <ng-container *ngIf="showJobType">
                  <ul class="all-template-list list--siderbar overflow-accordion gs-accordion-sub--list" *ngIf="jobTypesSearched">
                    <li *ngFor="let type of jobTypesSearched">
                      <a>
                        {{ type.name }}
                      </a>
                    </li>
                  </ul>
                </ng-container>
              </ul>
            </div>
          </li>
          <!-- 02 - status -->
          <li routerLinkActive="level-2-active">
            <a
              href="javascript:void(0)"
              *ngxPermissionsOnly="['task.status.create', 'task.status.edit', 'task.status.delete']"
              routerLink="/setting/tasks/status"
              routerLinkActive="active-highlight">
              Status</a
            >
            <div id="collapse2" class="collapse" data-parent="#accordion" routerLinkActive="show" [class.show]="status_tab" routerLinkActive="show">
              <ul class="job-child">
                <div class="my-2 ml-1 site-searchbox position-relative with-left-icon">
                  <input
                    type="text"
                    class="site-input search-input"
                    [(ngModel)]="statusQuery"
                    (input)="fetchBySearchStatus()"
                    placeholder="Search Status" />
                  <i class="pi pi-search cp cs-icon" *ngIf="!statusQuery"></i>
                  <button (click)="getStatusData(); statusQuery = ''" type="reset" class="close-icon sm cs-icon" *ngIf="statusQuery"></button>
                </div>
                <li
                  class="d-flex align-items-center justify-content-between cursor-pointer"
                  (click)="showStatusType = !showStatusType"
                  [class.open]="showStatusType"
                  [class.close]="!showStatusType">
                  <a href="javascript:void(0);" [class.open]="showStatusType" [class.close]="!showStatusType"> All </a>
                  <ng-container *ngIf="showStatusType; else down_angle">
                    <i class="pi pi-angle-down"></i>
                  </ng-container>
                  <ng-template #down_angle>
                    <i class="pi pi-angle-up"></i>
                  </ng-template>
                </li>
                <ng-container *ngIf="showStatusType">
                  <ul class="all-template-list list--siderbar overflow-accordion gs-accordion-sub--list" *ngIf="SearchedStatuses">
                    <li *ngFor="let st of SearchedStatuses">
                      <a>
                        {{ st.name }}
                      </a>
                    </li>
                  </ul>
                </ng-container>
              </ul>
            </div>
          </li>
          <!-- 03 - Priority -->
          <li routerLinkActive="level-2-active">
            <a
              href="javascript:void(0)"
              *ngxPermissionsOnly="['task.priority.manage']"
              routerLink="/setting/tasks/priority"
              routerLinkActive="active-highlight"
              >Priority</a
            >
            <div id="Offices" class="collapse" data-parent="#accordion" [class.show]="priority" routerLinkActive="show">
              <ul class="job-child">
                <div class="my-2 ml-1 site-searchbox position-relative with-left-icon">
                  <input
                    type="text"
                    class="site-input search-input"
                    [(ngModel)]="priorityQuery"
                    (input)="fetchPrioritiesBySearch()"
                    placeholder="Search Priority" />
                  <i class="pi pi-search cp cs-icon" *ngIf="!priorityQuery"></i>
                  <button (click)="getPrioritiesData(); priorityQuery = ''" type="reset" class="close-icon sm cs-icon" *ngIf="priorityQuery"></button>
                </div>
                <li
                  class="d-flex align-items-center justify-content-between cursor-pointer"
                  (click)="showPriorityType = !showPriorityType"
                  [class.open]="showPriorityType"
                  [class.close]="!showPriorityType">
                  <a href="javascript:void(0);" [class.open]="showPriorityType" [class.close]="!showPriorityType"> All </a>
                  <ng-container *ngIf="showPriorityType; else down_angle">
                    <i class="pi pi-angle-down"></i>
                  </ng-container>
                  <ng-template #down_angle>
                    <i class="pi pi-angle-up"></i>
                  </ng-template>
                </li>
                <ng-container *ngIf="showPriorityType">
                  <ul class="all-template-list list--siderbar overflow-accordion gs-accordion-sub--list" *ngIf="searchedPriorities">
                    <li *ngFor="let st of searchedPriorities">
                      <a routerLinkActive="active" [routerLink]="['/setting/tasks/priority/edit', st._id ? st._id : st.id]">
                        {{ st.name }}
                      </a>
                    </li>
                  </ul>
                </ng-container>
              </ul>
            </div>
          </li>
        </ul>
        <hr class="mt-2 mb-2" style="color: grey" />
      </li>
    </ul>
  </div>
</div>
